import { render } from "./ListarPosts.vue?vue&type=template&id=52fef691"
import script from "./ListarPosts.vue?vue&type=script&lang=js"
export * from "./ListarPosts.vue?vue&type=script&lang=js"

import "./ListarPosts.vue?vue&type=style&index=0&id=52fef691&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__